import type { ILayerBehavior, ITableLayerProps } from '@/version-types';
import { collectTableLayerFonts } from '../utils/table';

type Behaviors = Pick<ILayerBehavior, 'getTextInfo' | 'isTextEditable'>;

export const createFontBehaviors = () => {
    const behaviors: Behaviors = {
        isTextEditable: () => true,

        getTextInfo: (layer) => collectTableLayerFonts(layer.data as ITableLayerProps),
    };

    return behaviors;
};
